exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-projects{padding:0}.projects-showcase{list-style:none;width:100%}.projects-showcase li{display:block;float:left;width:25%}.project-photo{width:100%;margin:0;overflow:hidden;background-color:#000}.project-photo img{opacity:.7;width:100%;height:auto;-webkit-transform:scale(1.15);transform:scale(1.15);-webkit-transition:-webkit-transform .5s,opacity .5s;transition:transform .5s,opacity .5s}.project-photo img:hover{opacity:1;-webkit-transform:scale(1.03);transform:scale(1.03)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-2bff9406","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sections/Projects.vue
// module id = 41
// module chunks = 0